import { render, staticRenderFns } from "./DocumentUnique.vue?vue&type=template&id=b8a60304&"
import script from "./DocumentUnique.vue?vue&type=script&lang=js&"
export * from "./DocumentUnique.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUnique.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports